import React from "react";
import "./index.scss";

interface SwitchButtonProps {
  value: boolean;
  onToggle: (value: boolean) => void;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({ value, onToggle }) => {
  return (
    <div className={`switch-button ${value ? "active" : ""}`} onClick={() => onToggle(!value)}>
      <div className="switch-thumb"></div>
    </div>
  );
};

export default SwitchButton;
